import axios from 'axios';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { LoadAllAccueil, LoadAllManagerAllPage, LoadAllManagerHomePage, UpdateAccueil } from '../../../../actions/ActivitesPages/ManagerPageAction';
import { baseUrl } from '../../../../nametitle/dataUrl';
import { getDataFromFile } from '../../../../actions/SearchAction';
import { Localvalue } from '../../../../nametitle/localValue';

const FormHome = () => {


    //. Activité 1
    const [reading, setreading] = useState(true);
    const [id, setid] = useState();

    const [coverPictureHome1, setcoverPictureHome1] = useState();
    const [videoHome, setVideoHome] = useState();
    const [titleHome, settitleHome] = useState();
    const [descriptionHome1, setdescriptionHome1] = useState();

    // Accitite 2
    const [coverPictureHome2, setcoverPictureHome2] = useState();
    const [versetHome2, setversetHome2] = useState();
    const [titleHome2, settitleHome2] = useState();
    const [description1, setdescription1] = useState();
    const [description2, setdescription2] = useState();


    const [coverPictureHome3, setcoverPictureHome3] = useState();
    const [titleHome3, settitleHome3] = useState();
    const [descriptionHome3, setdescriptionHome3] = useState();

    const [Loading, setLoading] = useState();

    useEffect(() => {

        const object = getDataFromFile(Localvalue.activitePageData);
        setVideoHome(object && object.accueil && object.accueil.activite1 && object.accueil.activite1.video ? object.accueil.activite1.video : "");
        setcoverPictureHome1(object && object.accueil && object.accueil.activite1 && object.accueil.activite1.coverPicture ? object.accueil.activite1.coverPicture : "");
        settitleHome(object && object.accueil && object.accueil.activite1 && object.accueil.activite1.title ? object.accueil.activite1.title : "");
        setdescriptionHome1(object && object.accueil && object.accueil.activite1 && object.accueil.activite1.description ? object.accueil.activite1.description : "");
        // ***************************************************     Activté 2
        setversetHome2(object && object.accueil && object.accueil.activite2 && object.accueil.activite2.verset ? object.accueil.activite2.verset : "");
        setcoverPictureHome2(object && object.accueil && object.accueil.activite2 && object.accueil.activite2.coverPicture ? object.accueil.activite2.coverPicture : "");
        settitleHome2(object && object.accueil && object.accueil.activite2 && object.accueil.activite2.title ? object.accueil.activite2.title : "");
        setdescription2(object && object.accueil && object.accueil.activite2 && object.accueil.activite2.description1 ? object.accueil.activite2.description1 : "");
        setdescriptionHome3(object && object.accueil && object.accueil.activite2 && object.accueil.activite2.description2 ? object.accueil.activite2.description2 : "");
        // *****************************************************   Activté 3
        setcoverPictureHome3(object && object.accueil && object.accueil.activite3 && object.accueil.activite3.coverPicture ? object.accueil.activite3.coverPicture : "");
        settitleHome3(object && object.accueil && object.accueil.activite3 && object.accueil.activite3.title ? object.accueil.activite3.title : "");
        setdescriptionHome3(object && object.accueil && object.accueil.activite3 && object.accueil.activite3.description ? object.accueil.activite3.description : "");

        LoadAllAccueil(
            setid,
            setVideoHome, setcoverPictureHome1, setdescriptionHome1, settitleHome,
            setcoverPictureHome2, setversetHome2, settitleHome2, setdescription1, setdescription2,
            setcoverPictureHome3, setdescriptionHome3, settitleHome3
        );
    }, []);
    function ReadChamp() {
        setreading(!reading)
    }

    // Upload des fichier 
    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader(); fileReader.readAsDataURL(file); fileReader.onload = () => { resolve(fileReader.result); };
            fileReader.onerror = (error) => { reject(error); };
        });
    };

    // Video 
    function uploadSingleVideo(base64) {
        setLoading(true);
        axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
            .then((res) => { setVideoHome(res.data); alert("vidéo uploaded Succesfully"); })
            .then(() => setLoading(false))
            .catch(console.log);
    }
    const uploadVideo = async (event) => {
        const files = event.target.files;
        console.log(files.length);
        if (files.length === 1) {
            const base64 = await convertBase64(files[0]);
            uploadSingleVideo(base64); return;
        }
        const base64s = [];
        for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
    };




    // Image 1
    function uploadSingleImage1(base64) {
        setLoading(true);
        axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
            .then((res) => { setcoverPictureHome1(res.data); alert("image uploaded Succesfully"); })
            .then(() => setLoading(false))
            .catch(console.log);
    }
    const uploadImage1 = async (event) => {
        const files = event.target.files;
        console.log(files.length);
        if (files.length === 1) {
            const base64 = await convertBase64(files[0]);
            uploadSingleImage1(base64); return;
        }
        const base64s = [];
        for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
    };



    // Image 2
    function uploadSingleImage2(base64) {
        setLoading(true);
        axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
            .then((res) => { setcoverPictureHome2(res.data); alert("image uploaded Succesfully"); })
            .then(() => setLoading(false))
            .catch(console.log);
    }
    const uploadImage2 = async (event) => {
        const files = event.target.files;
        console.log(files.length);
        if (files.length === 1) {
            const base64 = await convertBase64(files[0]);
            uploadSingleImage2(base64); return;
        }
        const base64s = [];
        for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
    };


    // Image 1
    function uploadSingleImage3(base64) {
        setLoading(true);
        axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
            .then((res) => { setcoverPictureHome3(res.data); alert("image uploaded Succesfully"); })
            .then(() => setLoading(false))
            .catch(console.log);
    }
    const uploadImage3 = async (event) => {
        const files = event.target.files;
        console.log(files.length);
        if (files.length === 1) {
            const base64 = await convertBase64(files[0]);
            uploadSingleImage3(base64); return;
        }
        const base64s = [];
        for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
    };



    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();

                UpdateAccueil(id, videoHome, coverPictureHome1, descriptionHome1,
                    titleHome, coverPictureHome2, versetHome2, titleHome2, description1,
                    description2, coverPictureHome3, descriptionHome3, titleHome3
                )
            }}
        >
            <h2 className="translatable text-2xl py-2 bg-light">Page Accueil</h2>


            <div className="translatable input-group mb-3 flex flex-row space-x-5">
                <input onChange={ReadChamp} type="checkbox" className="translatable h-[30px] w-[30px]" />
                <label>rendre les champ disponible </label>
            </div>
            <div className="translatable bg-info my-3">
                <h2>activté 1</h2>
            </div>

            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">Vidéo</span>
                    <input onChange={uploadVideo} readOnly={reading} type="file" className="translatable form-control" accept=".MP4" placeholder="" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable border-green-400 p-3">
                {coverPictureHome1 && (<img src={`${coverPictureHome1}`} className="translatable h-[100px] w-[100px]" />)}
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">Image de vidéo</span>
                    <input onChange={uploadImage1} readOnly={reading} type="file" className="translatable form-control" accept=".JPG , PNG, JPEG" placeholder="" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">titre de vidéo</span>
                    <input readOnly={reading} value={titleHome} onChange={(e) => { settitleHome(e.target.value) }} type="text" className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable border-green-400 p-3">

                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">description</span>
                    <textarea readOnly={reading} value={descriptionHome1} onChange={(e) => { setdescriptionHome1(e.target.value) }} className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>




            <div className="translatable bg-info my-3">
                <h2>activté 2</h2>
            </div>


            <div className="translatable border-green-400 p-3">
                {coverPictureHome2 && (<img src={`${coverPictureHome2}`} className="translatable h-[100px] w-[100px]" />)}
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">Image de fond</span>
                    <input onChange={uploadImage2} readOnly={reading} type="file" className="translatable form-control" accept=".JPG , PNG, JPEG" placeholder="" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">titre de vidéo</span>
                    <input readOnly={reading} value={titleHome2} onChange={(e) => { settitleHome2(e.target.value) }} type="text" className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">verset</span>
                    <input readOnly={reading} value={versetHome2} onChange={(e) => { setversetHome2(e.target.value) }} type="text" className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">description 1</span>
                    <textarea readOnly={reading} value={description1} onChange={(e) => { setdescription1(e.target.value) }} className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">description 2</span>
                    <textarea readOnly={reading} value={description2} onChange={(e) => { setdescription2(e.target.value) }} className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable bg-info my-3">
                <h2>activté 3</h2>
            </div>


            <div className="translatable border-green-400 p-3">
                {coverPictureHome3 && (<img src={`${coverPictureHome3}`} className="translatable h-[100px] w-[100px]" />)}
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">Image de fond</span>
                    <input onChange={uploadImage3} readOnly={reading} type="file" className="translatable form-control" accept=".JPG , PNG, JPEG" placeholder="" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">titre </span>
                    <input readOnly={reading} value={titleHome3} onChange={(e) => { settitleHome3(e.target.value) }} type="text" className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">description</span>
                    <textarea readOnly={reading} value={descriptionHome3} onChange={(e) => { setdescriptionHome3(e.target.value) }} className="translatable form-control" placeholder=" " aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable  mb-3 mt-5">
                <button type="submit" className="translatable btn bg-gray-900 btn-dark py-3 px-2">Enregistrer changement </button>
            </div>

        </form>
    )
}

export default FormHome